module.exports = __webpack_public_path__ + "img/183-13cde9.png";